/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './configurator-attribute-composition.config';
export * from './configurator-attribute-composition.directive';
export * from './configurator-attribute-composition.model';
export * from './configurator-attribute-composition.module';
